import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';

interface navDrawerState {
  searchQuery: string;
  conversationsOnly?: boolean;
}

const initialState: navDrawerState = {
  searchQuery: '',
  conversationsOnly: undefined,
};

const navDrawerStateSlice = createSlice({
  name: 'navDrawer',
  initialState,
  reducers: {
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
    setConversationsOnly: (state, action: PayloadAction<boolean | undefined>) => {
      state.conversationsOnly = action.payload;
    },
  },
});

export const { setSearchQuery, setConversationsOnly } = navDrawerStateSlice.actions;

export const selectNavDrawer = (state: RootState) => state.navDrawer;

export default navDrawerStateSlice.reducer;
